var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1387_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9993 2.16669C7.01935 2.16669 2.16602 7.02002 2.16602 13C2.16602 18.98 7.01935 23.8334 12.9993 23.8334C18.9793 23.8334 23.8327 18.98 23.8327 13C23.8327 7.02002 18.9793 2.16669 12.9993 2.16669ZM10.0635 17.6475L6.17435 13.7584C5.75185 13.3359 5.75185 12.6534 6.17435 12.2309C6.59685 11.8084 7.27935 11.8084 7.70185 12.2309L10.8327 15.3509L18.286 7.89752C18.7085 7.47502 19.391 7.47502 19.8135 7.89752C20.236 8.32002 20.236 9.00252 19.8135 9.42502L11.591 17.6475C11.1793 18.07 10.486 18.07 10.0635 17.6475Z",
    fill: "#00B066"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1387_760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCheck);
export default __webpack_public_path__ + "static/media/Big-Check.c911e9e31872848974692ccddf5ac398.svg";
export { ForwardRef as ReactComponent };